document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('kannaki-filter-trigger');
  const drawer = document.getElementById('kannaki-filter-drawer');
  const backdrop = document.getElementById('kannaki-filter-drawer-backdrop');
  const closeBtn = document.getElementById('kannaki-filter-drawer-close');
  const form = document.getElementById('kannaki-filter-form');
  const clearBtn = document.getElementById('kannaki-filter-clear');
  const applyBtn = document.getElementById('kannaki-filter-apply');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden'; // Prevent main page scrolling while drawer is open
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (trigger) trigger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  // Close on Escape key press
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  function applyFilters() {
    if (!form) return;

    // Serialize form data
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value && value.trim() !== '') {
        params.append(key, value);
      }
    }

    // Preserve existing search query parameters if on search page
    const currentUrlParams = new URLSearchParams(window.location.search);
    if (currentUrlParams.has('q') && !params.has('q')) {
      params.set('q', currentUrlParams.get('q'));
    }
    if (currentUrlParams.has('options[prefix]') && !params.has('options[prefix]')) {
      params.set('options[prefix]', currentUrlParams.get('options[prefix]'));
    }

    const queryString = params.toString();
    const baseUrl = window.location.pathname;
    const targetUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    // Find grid container across search or collection pages
    const currentGrid = document.querySelector('.kannaki-cinematic-search-grid, .product-grid, .kannaki-editorial-grid, .main-collection-grid');
    if (currentGrid) {
      currentGrid.style.opacity = '0.4';
      currentGrid.style.transition = 'opacity 0.3s ease';
    }

    fetch(targetUrl)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('.kannaki-cinematic-search-grid, .product-grid, .kannaki-editorial-grid, .main-collection-grid');

        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
          currentGrid.style.opacity = '1';
        } else {
          // Fallback if grid container isn't found
          window.location.href = targetUrl;
          return;
        }

        // Update count meta if present
        const newCount = doc.querySelector('.kannaki-search-count-meta');
        const currentCount = document.querySelector('.kannaki-search-count-meta');
        if (newCount && currentCount) {
          currentCount.innerHTML = newCount.innerHTML;
        }

        // Update browser history URL without page reload
        history.pushState({ path: targetUrl }, '', targetUrl);

        // Close drawer cleanly
        closeDrawer();

        // Scroll smoothly to top of products grid (prevents jumping to footer)
        if (currentGrid) {
          const headerOffset = 100;
          const elementPosition = currentGrid.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      })
      .catch(error => {
        console.error('Error fetching filtered results:', error);
        window.location.href = targetUrl;
      });
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      applyFilters();
    });
  }

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      applyFilters();
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (form) {
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(cb => cb.checked = false);
        const numberInputs = form.querySelectorAll('input[type="number"]');
        numberInputs.forEach(input => input.value = '');
        applyFilters();
      }
    });
  }
});
